module.exports = __webpack_public_path__ + "img/main.9c059943.png";